import { autoinject } from 'aurelia-framework';
import { DialogController, DialogService } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { SecurityService } from '../../services/security-service';
import 'jquery';
import 'notify';
import * as moment from 'moment';
import { BusyService } from '../../services/busy-service';
import { RequestDto } from '../../data/typegen/dtos/request-dto';
import { CarrierStatus } from '../carrier-status-history';
import { PromptDialog } from '../../resources/dialogs/prompt-dialog';
import { SimpleDialog } from './simple-dialog';

@autoinject
export class CarrierStatusDialog {
    public requestNumber: string;
    requestId: string;
    constructor(
        protected controller: DialogController,
        private securityService: SecurityService,
        private busyService: BusyService,
        private api: WebApiService,
        private dialog: DialogService
    ) { }

    carrierStatuses: any;
    id: number;
    carrierId: number;
    carrierName: string;
    originalCarrierStatus: number;
    carrierStatusEntry: any;

    activate(params) {
        this.id = params.id;
        this.carrierId = params.carrier.id;
        this.carrierStatuses = params.carrierStatuses;
        this.carrierName = params.carrier.legalName;
        this.originalCarrierStatus = params.carrier.status;


        this._loadCarrierStatusEntry(this.id);
        this._loadCarrierStatuses();
    }

    _loadCarrierStatusEntry(id) {
        if (id) {
            this.busyService.on();
            return this.api.get("Carriers", "GetCarrierStatusEntry", { statusHistoryId: id })
                .then((result) => {
                    this.carrierStatusEntry = JSON.parse(result.response);
                })
                .finally(() => this.busyService.off());
        } else {
            this.carrierStatusEntry = {
                id: 0,
                carrierId: this.carrierId,
                statusId: this.originalCarrierStatus,
                // beginOn: moment(new Date()).format("MM/DD/YYYY h:mm a")
            };
        }
    }

    async _loadCarrierStatuses() {
        this.busyService.on();

        const result = await this.api.get("Carriers", "GetCarrierRequest", { carrierId: this.carrierId, includeClosed: false });
        const request: RequestDto = JSON.parse(result.response || null);

        if (request) {
            this.requestNumber = request.number;
            this.requestId = request.requestId;
        }

        var contractsAndInsuranceLeadsGroupId = "a86a7675-52ab-401e-b8a2-aaca50c7ffdc";
        const isContractsAndInsuranceLeadsMember = this.securityService.hasGroup(contractsAndInsuranceLeadsGroupId);

        return this.api.get("Carriers", "GetCarrierStatuses")
            .then((result) => {

                const statuses = JSON.parse(result.response);
                const filteredStatuses = statuses.filter(status => {
                    // 12/29/2022 Restrict carrier status changes, even for admin.  
                    // if (this.securityService.hasRole("admin")) {
                    //     return true;
                    // }

                    // 01-19-2023 Alisa needs to be able to change carrier Status  - but do not allow for carrers that have a request associated
                    if (isContractsAndInsuranceLeadsMember && !this.requestNumber) {
                        return true;
                    }

                    if (this.securityService.hasRole("carrier manager")) {
                        if (status.id == 10 /* Inactive */ || status.id == 11  /* Master Approved - Dormant */ || status.id == 13  /* Suspended */ || status.id == 14 /* Abandoned */) {
                            return true;
                        }
                    }

                    // User Story 12373: C&I Leads should be able to set carrier status to master approved
                    if (status.id == 8) {
                        if (isContractsAndInsuranceLeadsMember) {
                            if (this.requestNumber) {
                                if (!request.active) {
                                    // can't manually set to master approved for a carrier with an active request
                                    return false;
                                }
                            }
                            return true;
                        }
                    }

                    return false;
                });

                filteredStatuses.unshift({});
                this.carrierStatuses = filteredStatuses;
            })
            .finally(() => this.busyService.off());
    }

    delete() {
        this.api.post("Carriers", "DeleteCarrierStatus", this.carrierStatusEntry)
            .then(() => {
                //close dialog
                this.controller.ok();
            }, () => {
                $["notify"]("Error saving status", { className: "error", position: "top center" });
            });
    }

    async save() {

        if (!this.carrierStatusEntry.statusId) {
            alert("Status is required");
            return;
        }

        //if no reason specified, then show error
        if (!(this.carrierStatusEntry.comment && this.carrierStatusEntry.comment.trim())) {
            alert("Reason is required");
            return;
        }

        //if inserting a new status record for same status, then show error
        if (!this.id && (this.carrierStatusEntry.statusId == this.originalCarrierStatus)) {
            alert("Carrier is already in this status.");
            return;
        }

        // show alert in diaog when suspended or dormant is selected.
        if (!this.id && (this.carrierStatusEntry.statusId == 13 /* suspended */
            || this.carrierStatusEntry.statusId == 11 /* Master Approved - Dormant */
        )) {
            var confirmStatusEmail = await new Promise((resolve, reject) => {
                this.dialog.open(
                    {
                        viewModel: SimpleDialog,
                        model: {
                            title: "Confirm status change for " + this.carrierName,
                            message: "Choosing this status will trigger an email alert that is sent to all Carrier notification subscribers.  Do you want to continue?",
                            buttons: ["yes", "no"]
                        }
                    })
                    .whenClosed((result) => {
                        resolve(result.output == "yes");
                    });
            });
            if (!confirmStatusEmail) {
                return;
            }
        }

        this.api.post("Carriers", "ChangeCarrierStatus", this.carrierStatusEntry)
            .then(() => {
                //close dialog
                this.controller.ok({
                    status: this.carrierStatusEntry.statusId
                });
            }, () => {
                $["notify"]("Error saving status", { className: "error", position: "top center" });
            });
    }


}